import { fetch, Uri } from '../utils/fetch';
import cruiseModel from '../models/cruise';

export const fetchCruises = async (
  siteSettings,
  userId,
) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...cruiseModel,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/cruise/packages',
    query,
  });
  const response = await fetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchCruisesForInspiration = async (
  siteSettings,
  userId,
) => {
  const { siteId, apiUrl, baseUrl, areaId, cruiseShipId } = siteSettings;

  const query = {
    siteId,
    userId,
    areaId,
    cruiseShipId,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/cruise/packagesForInspiration',
    query,
  });
  const response = await fetch.getJsonByProxy(uri, baseUrl);
  return response;
};


export const fetchCabins = async (
  siteSettings,
  userId,
) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...cruiseModel,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/cruise/listCabins',
    query,
  });
  const response = await fetch.getJsonByProxy(uri, baseUrl);
  return response;
};
